const SurveySite = require("@/modules/surveys/components/SurveySite.vue")
  .default;
const SurveyManageSite = require("@/modules/surveys/components/SurveyManageSite.vue")
  .default;

const SurveyRoutes = [
  {
    name: "surveys.surveys",
    path: "/surveys/",
    component: SurveySite,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "surveys.manage.edit_survey",
    path: "/survey-manage/:id",
    component: SurveyManageSite,
    props: true,
    meta: {
      requiresAuth: true,
      back: "/surveys",
    },
  },
  {
    name: "surveys.manage.create_survey",
    path: "/survey-manage",
    component: SurveyManageSite,
    meta: {
      requiresAuth: true,
      back: "/surveys",
    },
  },
];

const SurveySettingsRoutes = [];

const SurveyBaseDataRoutes = [];

export { SurveyRoutes, SurveySettingsRoutes, SurveyBaseDataRoutes };
